import React, { useState } from 'react';
import { BarChart, Bar, AreaChart, Area, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { TrendingUp, Users, DollarSign, BarChart2, ArrowUpRight } from 'lucide-react';

const T = { bg2:'#0d1114', border:'rgba(255,255,255,.06)', muted:'#4a5a63', green:'#00c566' };
const COLORS = ['#00c566','#f5c842','#ff6b35','#0e8fff','#ff4444'];

export default function Analytics() {
  const [period, setPeriod] = useState('7d');
  const vol = Array.from({length:30},(_,i)=>({ d:`${i+1}`, v:Math.floor(Math.random()*800+200), t:Math.floor(Math.random()*40+10) }));
  const cats = [{name:'Crypto',value:45},{name:'Politics',value:25},{name:'Sports',value:15},{name:'Economy',value:10},{name:'Other',value:5}];
  const funnel = [{n:'Link Clicks',v:1240},{n:'App Opens',v:680},{n:'Wallet Created',v:312},{n:'First Trade',v:156}];

  return (
    <div>
      <h1 style={{ fontSize:'clamp(20px,4vw,28px)', fontWeight:800, marginBottom:4 }}>Analytics</h1>
      <p style={{ fontSize:14, color:T.muted, marginBottom:20 }}>Track your market performance and audience</p>

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {['7d','30d','90d','all'].map(p=>(
          <button key={p} onClick={()=>setPeriod(p)} style={{ padding:'7px 14px', borderRadius:8, border:`1px solid ${p===period?'rgba(0,197,102,.3)':T.border}`, background:p===period?'rgba(0,197,102,.08)':'rgba(255,255,255,.03)', color:p===period?T.green:T.muted, cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'inherit' }}>{p}</button>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))', gap:12, marginBottom:18 }}>
        {[[TrendingUp,'Total Volume','$2,450','#00c566'],[Users,'Unique Traders','87','#f5c842'],[BarChart2,'Total Trades','312','#ff6b35'],[DollarSign,'Royalties','$12.25','#00c566']].map(([Icon,label,val,color])=>(
          <div key={label} style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:14, padding:16 }}>
            <Icon size={16} color={color} style={{ marginBottom:10 }}/>
            <div style={{ fontSize:22, fontWeight:800 }}>{val}</div>
            <div style={{ fontSize:12, color:T.muted, marginTop:3 }}>{label}</div>
          </div>
        ))}
      </div>

      <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:20, marginBottom:14 }}>
        <div style={{ fontSize:15, fontWeight:700, marginBottom:4 }}>Trading Volume</div>
        <div style={{ fontSize:12, color:T.muted, marginBottom:16 }}>Last 30 days</div>
        <ResponsiveContainer width="100%" height={180}>
          <AreaChart data={vol}>
            <defs><linearGradient id="ag" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#00c566" stopOpacity={0.15}/><stop offset="95%" stopColor="#00c566" stopOpacity={0}/></linearGradient></defs>
            <XAxis dataKey="d" tick={{fill:T.muted,fontSize:10}} axisLine={false} tickLine={false} interval={4}/>
            <YAxis tick={{fill:T.muted,fontSize:10}} axisLine={false} tickLine={false} width={30}/>
            <Tooltip contentStyle={{background:'#0d1114',border:`1px solid ${T.border}`,borderRadius:8,fontSize:12}}/>
            <Area type="monotone" dataKey="v" stroke="#00c566" strokeWidth={2} fill="url(#ag)" dot={false}/>
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:14 }}>
        <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:20 }}>
          <div style={{ fontSize:15, fontWeight:700, marginBottom:14 }}>Volume by Category</div>
          <ResponsiveContainer width="100%" height={140}><PieChart><Pie data={cats} cx="50%" cy="50%" innerRadius={35} outerRadius={60} dataKey="value" paddingAngle={3}>{cats.map((_,i)=><Cell key={i} fill={COLORS[i%COLORS.length]}/>)}</Pie><Tooltip contentStyle={{background:'#0d1114',border:`1px solid ${T.border}`,borderRadius:8,fontSize:12}}/></PieChart></ResponsiveContainer>
          <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:8 }}>
            {cats.map((c,i)=>(<div key={c.name} style={{ display:'flex', alignItems:'center', gap:4, fontSize:11, color:T.muted }}><div style={{ width:8, height:8, borderRadius:'50%', background:COLORS[i%COLORS.length] }}/>{c.name} {c.value}%</div>))}
          </div>
        </div>

        <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:20 }}>
          <div style={{ fontSize:15, fontWeight:700, marginBottom:14 }}>Conversion Funnel</div>
          {funnel.map((f,i)=>{
            const pct=Math.round(f.v/funnel[0].v*100);
            return (
              <div key={f.n} style={{ marginBottom:12 }}>
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, marginBottom:4 }}>
                  <span style={{ color:T.muted }}>{f.n}</span>
                  <span style={{ fontWeight:600 }}>{f.v.toLocaleString()} <span style={{ color:T.muted }}>({pct}%)</span></span>
                </div>
                <div style={{ height:5, background:'rgba(255,255,255,.06)', borderRadius:3, overflow:'hidden' }}>
                  <div style={{ height:'100%', width:pct+'%', background:COLORS[i], borderRadius:3 }}/>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
